import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import filedata from "./filedata";
import Chart from "./Chart.jsx";
import "./BubbleChart.css";
import { useHistory, useParams } from "react-router-dom";

require("highcharts/modules/exporting")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
const Bubble = () => {
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const [width, setwidth] = useState(650);
  const [bubble, setbubble] = useState(200);
  useEffect(() => {
    if (window.innerWidth > 720) {
      setwidth(550);
      setbubble(200);
    } else {
      setwidth(690);
      setbubble(150);
    }
  }, [window.innerWidth]);
  let { pathid, subid } = useParams();

  const history = useHistory();
  const [data, setdata] = useState([]);
  useEffect(() => {
    if (pathid !== undefined) {
      const val = filedata.Wholedata.filter((data) => data.id === pathid);
      const arr = val[0].data.map((obj) => {
        const oneobject = {};
        oneobject.name = capitalizeFirstLetter(obj.name);
        oneobject.id = obj.id;
        oneobject.value = 50;
        return oneobject;
      });
      if (arr.length === 3) {
        setbubble(170);
      } else if (arr.length === 4) {
        setbubble(270);
      } else if (arr.length === 5) {
        setbubble(200);
      } else if (arr.length === 1) {
        setbubble(300);
      } else if (arr.length === 2) {
        setbubble(200);
      }
      setdata([...arr]);
    } else if (pathid === undefined) {
      const arr = filedata.Wholedata.map((obj) => {
        const oneobject = {};
        oneobject.name = capitalizeFirstLetter(obj.name);
        oneobject.id = obj.id;
        oneobject.value = 50;
        return oneobject;
      });
      setdata([...arr]);
    }
  }, [pathid, subid]);
  const chartOptions = {
    chart: {
      type: "packedbubble",
      height: width,
      minHeight: "600",
    },
    title: {
      text: "",
    },
    subTitle: {},
    tooltip: { enabled: false },
    plotOptions: {
      packedbubble: {
        series: {
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
          },
        },
        maxSize: bubble,
        minSize: bubble,
        stacking: undefined,
        sizeBy: "width",
        backgroundColor: "#000000",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>",
          style: {
            color: "black",
            textOutline: "none",
            fontWeight: "normal",
            overflow: "justify",
          },
        },
        point: {
          events: {
            click: (e) => {
              if (pathid !== undefined) {
                history.push(e.point.id + "/");
              } else if (pathid === undefined) {
                history.push("/cheatsheet/" + e.point.id + "/");
              }
            },
          },
        },
      },
    },

    colors: ["#f5faff"],
    series: {
      name: { pathid },
      data: [...data],
    },
  };
  return (
    <div>
      <Chart options={chartOptions} highcharts={Highcharts} />
    </div>
  );
};
export default Bubble;
